/**
 * Display PWA - Front Desk Display
 * Domain: display.chain29.com
 * 
 * Customer-facing display at front desk:
 * - Real-time checkout display (SSE)
 * - Order queue status
 * - Ready order announcements
 * - Promotional content
 * - Wait times
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { pwaPath } from '@/utils/getBasePath';
import { Toaster } from 'sonner';
import { Monitor } from 'lucide-react';
import { PwaAccountGate } from '@/components/pwa/PwaAccountGate';

// Pages
import DisplayMainPage from './pages/DisplayMainPage';
import SettingsPage from './pages/SettingsPage';
import FrontDeskDisplayPage from './pages/FrontDeskDisplayPage';

// Context
import { DisplayProvider } from './context/DisplayContext';

// The display names its restaurant: the signed-in restaurant account
// (components/pwa); no account, no screen.
export default function DisplayApp() {
  return (
    <>
      <Toaster position="top-center" richColors />
      <PwaAccountGate appName="Customer Display" icon={Monitor} accent="#3b82f6">
        {(account) => (
          <DisplayProvider key={`${account.restaurant.id}:${account.signedInAt}`}>
            <Routes>
              {/* Front Desk Display with SSE - Primary route */}
              <Route path="t/:terminalId" element={<FrontDeskDisplayPage />} />
              
              {/* Order Status Display */}
              <Route index element={<DisplayMainPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="*" element={<Navigate to={pwaPath('display')} replace />} />
            </Routes>
          </DisplayProvider>
        )}
      </PwaAccountGate>
    </>
  );
}
